import { axiosCms } from 'Axios.js';
import { authToken } from '../utility';
import * as actionTypes from './actionTypes';

const fetchInventoryUploadsStart = () => ({ type: actionTypes.FETCH_INV_UPLOADS_START });

const fetchInventoryUploadsEnd = data => ({ type: actionTypes.FETCH_INV_UPLOADS_END, data });

export const fetchInventoryUploads = () => {
  return dispatch => {
    dispatch(fetchInventoryUploadsStart());

    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());

    return axiosCms
      .get('/inventory_uploads')
      .then(response => {
        const { data } = response;
        dispatch(fetchInventoryUploadsEnd(data));
        return 'done';
      })
      .catch(err => {
        console.error(`fetchInventoryUploads err: `, err);
        return Promise.reject(err);
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/inventory.js